<template>
  <div class="animated fadeIn">
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <!-- <v-btn elevation="6" outlined small
            ><i class="fa fa-arrow-left text-dark"></i
          ></v-btn>
          تب بعدی <br /> -->
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog" hide-overlay persistent width="300">
      <v-card class="p-2" dark>
        <v-card-text class="text-center">
          لطفا کمی صبر کنید...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <b-card style="border: 0" class="mt-0 mb-0" header-bg-variant="primary">
      <template v-slot:header>
        <h4>تغییر رمز عبور</h4>
      </template>

      <v-text-field
        label="رمز عبور فعلی"
        :type="showPass ? 'text' : 'password'"
        v-model="oldPassword"
        @click:append="showPass = !showPass"
        outlined
        dense
      ></v-text-field>

      <v-text-field
        label="رمز عبور جدید"
        :type="showPass ? 'text' : 'password'"
        v-model="password"
        @input="passStrength"
        @click:append="showPass = !showPass"
        outlined
        dense
      ></v-text-field>

      <br />
      <!--============== checking password =========== -->
      <v-row class="w-50">
        <v-col>
          <!-- NOTE check if the pass has more than 8 charector -->
          <p class="pass" :class="{ 'pass--passed': password.length > 7 }">
            <i
              class="frmIcon fa"
              :class="password.length > 7 ? 'fa-check' : 'fa-times'"
            ></i>
            حداقل ۸ نویسه
          </p>
        </v-col>
        <v-col>
          <!-- NOTE check if the pass has uppercase -->
          <p class="pass" :class="{ 'pass--passed': has_uppercase }">
            <i
              class="frmIcon fa"
              :class="has_uppercase ? 'fa-check' : 'fa-times'"
            ></i>
            دارای حروف بزرگ باشد
          </p>
        </v-col>
      </v-row>
      <v-row class="w-50">
        <v-col>
          <!-- NOTE check if the pass has lowercase -->
          <p class="pass" :class="{ 'pass--passed': has_lowercase }">
            <i
              class="frmIcon fa"
              :class="has_lowercase ? 'fa-check' : 'fa-times'"
            ></i>
            دارای حروف کوچک باشد
          </p>
        </v-col>
        <v-col>
          <!-- NOTE check if the pass has number -->
          <p class="pass" :class="{ 'pass--passed': has_number }">
            <i
              class="frmIcon fa"
              :class="has_number ? 'fa-check' : 'fa-times'"
            ></i>
            دارای عدد باشد
          </p>
        </v-col>
      </v-row>

      <!--============== checking password =========== -->
      <!-- <b-form-input
          trim
          v-model="repeatPassword"
          type="password"
          aria-describedby="repeat-password"
          :state="checkPassword"
        ></b-form-input> -->

      <v-text-field
        label="تکرار رمز عبور جدید"
        :type="showPass ? 'text' : 'password'"
        v-model="repeatPassword"
        @input="passStrength"
        @click:append="showPass = !showPass"
        outlined
        dense
      ></v-text-field>

      <b-form-invalid-feedback id="repeat-password"
        >رمز عبور با تکرار آن همخوانی ندارد</b-form-invalid-feedback
      >
      <v-btn
        v-if="!showPass"
        class="float-left"
        @click="showPass = !showPass"
        color="success"
        >مشاهده رمز عبور</v-btn
      ><v-btn
        v-if="showPass"
        class="float-left"
        @click="showPass = !showPass"
        color="success"
        >مخفی کردن رمز عبور</v-btn
      >
      <b-button
        @click="changePassword()"
        :disabled="isBusy || checkPassword == false"
        >تغییر رمز</b-button
      >
      <!-- NOTE (b-changePass) to change the password -->
    </b-card>
  </div>
</template>

<script>
import Axios from "axios"; // NOTE (IMPORT) to read the data from back_end of project
import md5 from "js-md5";

export default {
  data() {
    return {
      guide: false,
      password: "",
      repeatPassword: "",
      oldPassword: "",
      codeSent: false,
      activationCode: "",
      newPass: "",
      repeatNewPass: "",
      countdown: 60,
      sendAgainDisbaled: false,
      busy: false,
      isBusy: false,
      has_number: false,
      has_lowercase: false,
      has_uppercase: false,
      dialog: false,
      showPass: false,
    };
  },
  computed: {
    checkPassword() {
      // NOTE (c-checkPass) to check that the password is not duplicate
      return this.password == this.repeatPassword ? null : false;
    },
    // NOTE this func check if the password has lowecase,uppercase and number
    passStrength() {
      this.has_number = /\d/.test(this.password);
      this.has_lowercase = /[a-z]/.test(this.password);
      this.has_uppercase = /[A-Z]/.test(this.password);
    },
  },
  methods: {
    toggleHelp() {
      this.guide = !this.guide;
    },
    changePassword() {
      if (
        this.has_number &&
        this.has_lowercase &&
        this.has_uppercase &&
        this.password.length > 7
      ) {
        this.dialog = true;
        // NOTE (m-changePassword) to change the password
        this.isBusy = true;
        Axios.post(
          this.baseUrl + "/ppkpms/user/changePassword",
          {
            password: md5(this.password),
            oldPassword: md5(this.oldPassword),
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
          .then((res) => {
            this.dialog = false;
            this.isBusy = false;
            this.password = "";
            this.repeatPassword = "";
            this.oldPassword = "";
            const title = (
              <div>
                <h5>ویرایش رمز</h5>
                <span>رمز شما با موفقیت تغییر کرد</span>
              </div>
            );
            this.toast(title, "success");
          })
          .catch((err) => {
            this.dialog = false;
            this.isBusy = false;
            this.toast(err.response.data, "error");
          });
      } else {
        this.toast(
          "لطفا جهت حفظ امنیت اطلاعات خود موارد خواسته شده را در رمز خود اعمال کنید",
          "error"
        );
      }
    },
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../assets/fonts/IRANSans(FaNum).ttf");
}
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  border-bottom: 1px solid #c8ced3;
}

.myselect2 {
  width: 100%;
}
/* pass validation style */
.pass {
  font-size: 13px;
}
.pass--passed {
  color: #717b85;
}
.frmIcon {
  color: #eb0029;
}
.pass--passed .frmIcon {
  color: #0fa140;
}
</style>
